import gql from 'graphql-tag';

export const gqlGetCollectionpoint = gql`
  query getCollectionpointById($id: Int) {
    getCollectionpointById(id: $id) {
      id
      name
      code
      contactPerson
      email
      addressLine1
      addressLine2
      addressArea
      addressCity
      addressNomos
      addressDistrict
      postalCode
      phone
      mobile
      companyVat
      companyTaxOffice
      regionId
      region {
        id
        name
      }
      profession {
        id
        name
      }
      cpGroup {
        id
        name
      }
      cpSubgroup {
        id
        name
      }
      cpSubsubgroup {
        id
        name
      }
    }
  }
`;

export const gqlGetCollectionOrders = gql`
  query getCollectionOrders($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionOrders(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        statusId
        code
        seriesId
        codePrefix
        codeNumber
        orderedDate
        collectionPointId
        collectorId
        legacyAppId
        recordDate
        isActive
        firstDate
        originatedFromId
        recordedById
        lastDate
        firstUser
        lastUser
        contactPerson
        notes
        isUrgent
        userString1
        userString2
        userDate1
        collectionpoint {
          id
          name
          addressLine1
          addressArea
          addressCity
          addressDistrict
          phone
        }
        collector {
          id
          name
        }
        collectionOrderState {
          id
          value
          name
        }
        collectionId
        collection {
          id
          code
          dateCollected
          collectionLines {
            id
            aa
            materialId
            qty
            finDispNote
            netWeight
            material {
              id
              name
            }
          }
          idocs {
            id
            identificationDocument
          }
        }
        collectionOrdersContainers {
          id
          containersQty
        }
      }
      recordCount
    }
  }
`;

export const gqlGetCollections = gql`
  query getCollections($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollections(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        dateCollected
        collectionPointId
        isActive
        collectionLines {
          id
          aa
          materialId
          qty
          finDispNote
          netWeight
          material {
            id
            name
          }
        }
        idocs {
          id
          identificationDocument
        }
      }
      recordCount
    }
  }
`;

export const gqlAddCollectionOrder = gql`
  mutation addCollectionOrder($data: CollectionOrderInput) {
    addCollectionOrder(data: $data) {
      id
      code
    }
  }
`;

export const gqlGetQuery = gql`
  query getRegions($limit: Int, $offset: Int, $order: String, $where: String) {
    getRegions(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        value
      }
      recordCount
    }
  }
`;

export const gqlGetNomoi = gql`
  query getNomoi($limit: Int, $offset: Int, $order: String, $where: String) {
    getNomoi(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
      }
      recordCount
    }
  }
`;

export const gqlGetTaxoffices = gql`
  query getTaxoffices($limit: Int, $offset: Int, $order: String, $where: String) {
    getTaxoffices(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        isActive
      }
      recordCount
    }
  }
`;

export const gqlUpdateCollectionpoint = gql`
  mutation UpdateCollectionpoint($data: CollectionpointInput) {
    updateCollectionpoint(data: $data) {
      id
      name
      notes
      addressLine1
      addressLine2
      postalCode
      addressArea
      addressCity
      addressNomos
      addressDistrict
      contactPerson
      phone
      mobile
      fax
      email
      companyVat
      companyTaxOffice
      imaCode
      region {
        id
        name
      }
    }
  }
`;

export const gqlGetCollPointContainers = gql`
  query getContainersOfCollectionPoint($collectionPointId: Int) {
    getContainersOfCollectionPoint(collectionPointId: $collectionPointId) {
      data {
        containerTypeId
        containerTypeName
        containersQty
      }
      recordCount
    }
  }
`;

export const gqlGetImaPdf = gql`
  query getImaPdf($collectionPointId: Int!, $year: Int!) {
    getImaPdf(collectionPointId: $collectionPointId, year: $year)
  }
`;

export const gqlGetRecyclingImpactStats = gql`
  query getRecyclingImpactStats($collectionPointId: Int!, $year: Int) {
    getRecyclingImpactStats(collectionPointId: $collectionPointId, year: $year) {
      year
      collectionPointWasteWeightTons
      collectionPointCo2SavedTons
    }
  }
`;
